import { AnyHTMLElement } from '../hooks/validation/types';

export function scrollElementToTop(targetElement: AnyHTMLElement) {
  let bodyOffsetTop = document.body.getBoundingClientRect().top || 0;
  let elementOffsetTop = targetElement?.getBoundingClientRect().top || 0;
  let offsetTop = elementOffsetTop - bodyOffsetTop;

  scrollFrameToYOffset(offsetTop);
}

function scrollFrameToYOffset(offset: number) {
  const messagePayload: PostMessageEventPayload = {
    type: 'scroll',
    payload: {
      top: offset,
      behavior: 'smooth',
    },
  };
  window.parent && window.parent.postMessage(messagePayload, '*');
}
